import { render, staticRenderFns } from "./form-from-template-widget.vue?vue&type=template&id=0c0cc3b4&"
import script from "./form-from-template-widget.vue?vue&type=script&lang=js&"
export * from "./form-from-template-widget.vue?vue&type=script&lang=js&"
import style0 from "./form-from-template-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports